import { workspaceQueryKeys as e } from "./useWorkspaceQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { workspacesApi as r } from "@maat/api-main";
//#region src/workspaces/useRemoveMemberMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: ({ workspaceId: e, userId: t }) => r.removeMember(e, t),
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.members() });
		}
	});
};
//#endregion
export { i as useRemoveMemberMutation };
